import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight, Heart, Baby, Cake, Feather, Sparkles } from "lucide-react";
import { THEME_LIST } from "@/lib/themes";

const ICONS = { heart: Heart, sparkles: Sparkles, baby: Baby, cake: Cake, dove: Feather };

export default function ThemeSelector() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-cream">
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-8 flex items-center justify-between">
        <button onClick={() => navigate("/")} className="btn-ghost" data-testid="back-home-btn">
          <ArrowLeft size={16} /> Inicio
        </button>
        <Link to="/" className="headline text-2xl text-ink">
          Fernebia<span className="script text-warmgold ml-1">·mx</span>
        </Link>
      </div>

      <div className="mx-auto max-w-6xl px-6 md:px-10 pt-8 pb-24">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="overline mb-6">
          Paso 1 · Elige tu temática
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="headline text-5xl md:text-6xl text-ink leading-tight max-w-3xl"
        >
          ¿Qué estás <span className="script text-warmgold text-6xl md:text-7xl">celebrando</span>?
        </motion.h1>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {THEME_LIST.map((t, i) => {
            const Icon = ICONS[t.icon] || Sparkles;
            return (
              <motion.button
                key={t.id}
                onClick={() => navigate(`/crear/${t.id}`)}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                whileHover={{ y: -6 }}
                className="group text-left"
                data-testid={`select-theme-${t.id}`}
              >
                <div className="relative arch-shape overflow-hidden aspect-[3/4] shadow-md group-hover:shadow-2xl transition-shadow duration-500">
                  <img src={t.concepts[0].image} alt={t.name} className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent" />
                  <div className="absolute top-4 left-4 glass px-3 py-1.5 rounded-full inline-flex items-center gap-2">
                    <Icon size={14} className="text-warmgold" />
                    <span className="text-xs uppercase tracking-widest text-ink">{t.tagline}</span>
                  </div>
                  <div className="absolute bottom-6 left-6 right-6">
                    <h3 className="headline text-3xl md:text-4xl text-white leading-none">{t.name}</h3>
                    <p className="text-white/90 text-sm mt-2">{t.description}</p>
                  </div>
                </div>
                <div className="mt-5 flex items-center justify-between px-1">
                  <span className="script text-warmgold text-xl">5 conceptos</span>
                  <span className="text-ink inline-flex items-center gap-1 text-sm group-hover:text-warmgold transition-colors">
                    Elegir <ArrowRight size={14} />
                  </span>
                </div>
              </motion.button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
